/**
 * Removes the boot splash (`#loading-bg` in index.html — the tail-wagging cat).
 *
 * The splash lives OUTSIDE `#app`, so mounting Vue no longer wipes it. It stays up through the
 * first route's access check and the layout chunks, and comes down only when a real shell has
 * mounted. Callers are the shells' `onMounted`:
 * `layouts/components/DefaultLayoutWith{Vertical,Horizontal}Nav.vue` and `layouts/blank.vue`.
 *
 * Safety nets, so the splash can never trap the app behind it: `router.onError` and a timeout
 * in `main.ts` call it too.
 *
 * Idempotent: every call after the first is a no-op.
 */
const FADE_FALLBACK_MS = 400;

let hidden = false;

export function hideBootSplash() {
  if (hidden || typeof document === "undefined")
    return;

  hidden = true;

  const splash = document.getElementById("loading-bg");
  if (!splash)
    return;

  // One frame first, so the shell that called us has actually painted under the splash.
  requestAnimationFrame(() => {
    const remove = () => splash.remove();

    splash.addEventListener("transitionend", remove, { once: true });
    splash.classList.add("is-hiding");

    // `transitionend` never fires under reduced motion or in a background tab.
    window.setTimeout(remove, FADE_FALLBACK_MS);
  });
}
